import { UseQueryResult } from "@tanstack/react-query";
import { AxiosHeaders } from "axios";

import { UseFetchOptions } from "../types/StoryblokTypes";
import { WalkthroughStory } from "../types/WalkthroughTypes";
import { useStoryblokProxy } from "./useStoryblokProxy";

interface WalkthroughResponse {
  storyData: WalkthroughStory[];
  headers: AxiosHeaders;
}

export const useGetWalkthrough = (
  args: UseFetchOptions,
  abortRequest?: boolean
) => {
  const storyblokData = useStoryblokProxy(args, abortRequest);

  return {
    ...storyblokData,
    data: {
      storyData: storyblokData.data?.stories,
      headers: storyblokData.data?.headers,
    },
  } as unknown as UseQueryResult<WalkthroughResponse>;
};
